module.exports = lib_ekuaibao__i18n;